import React from 'react';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { ExpandableMenuItemContent, ExpandableMenuItemTrigger } from '@atlaskit/navigation-system';
import { useFormattedMessageAndIcon } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';

import { Nav4ExpandableMenuItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-expandable-menu-item/index.tsx';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { NAVIGATION_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import {
	MENU_ID_COMMUNICATION,
	MENU_ID_COMMUNICATIONS_STAKEHOLDERS,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { FIXED_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { getTestId } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/get-test-id/index.tsx';
import { useConfigurableMessageAndIconMap } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { L1_MENU_ID } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import messages from '../common/content/message.tsx';
import type { Props } from './types.tsx';

export type Nav4CommunicationsProps = {
	isExpanded?: boolean;
};

export const Nav4Communications = ({ isExpanded = false }: Props) => {
	const { icon: stakeholdersIcon, formattedMessage: stakeholdersMessage } =
		useFormattedMessageAndIcon(messages.stakeholders, PeopleGroupIcon);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formattedMessage: triggerFormattedMessage, icon: triggerIcon } =
		useConfigurableMessageAndIconMap(L1_MENU_ID.COMMUNICATION);

	const menuId = MENU_ID_COMMUNICATION;

	return (
		<Nav4ExpandableMenuItem menuId={menuId} isExpanded={isExpanded}>
			<ExpandableMenuItemTrigger
				testId={getTestId(menuId)}
				elemBefore={triggerIcon}
				interactionName={
					fg('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-communication' : undefined
				}
			>
				{triggerFormattedMessage}
			</ExpandableMenuItemTrigger>
			<ExpandableMenuItemContent>
				<Nav4MenuLinkItem
					menuId={MENU_ID_COMMUNICATIONS_STAKEHOLDERS}
					href="/jira/communications/stakeholders"
					elemBefore={stakeholdersIcon}
					onClick={() => {
						fireUIAnalytics(createAnalyticsEvent({}), {
							action: 'clicked',
							actionSubject: NAVIGATION_ITEM,
							actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_COMMUNICATION],
							attributes: {
								componentType: FIXED_ITEM,
								level: LEVEL_ONE,
								itemId: 'stakeholders',
							},
						});
					}}
				>
					{stakeholdersMessage}
				</Nav4MenuLinkItem>
			</ExpandableMenuItemContent>
		</Nav4ExpandableMenuItem>
	);
};
